import React, { useState } from "react";
import Header from "../../Components/comman/Header";
import { Container, Form } from "react-bootstrap";
import ThemeButtom from "../../Components/ThemeButtom";
import MobileHeader from "../../Components/comman/MobileHeader";
import axios from "axios";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import { Notification, Placeholder, toaster } from "rsuite";
import { Bounce, ToastContainer, toast } from "react-toastify";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    who_am_i: "creator",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // console.log(formData);
  };

  const handleContactUs = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const config = {
      url: ApiUrl.contactUs,
      method: "POST",
      body: formData,
    };

    APIRequest(
      config,
      (res) => {
        setIsLoading(false);
        setSuccessMessage(res.message);
        toaster.push(
          <Notification type="success" header="success">
            {res.message}
          </Notification>,
          {
            placement: "topCenter",
          }
        );
        setFormData({ name: "", email: "", who_am_i: "creator", message: "" });
      },
      (err) => {
        setIsLoading(false);
        if (err.response?.status === 422) {
          setValidationErrors(err.response.data.errors);
        } else if (err.response?.status === 500) {
          alert("Server error. Please try again later.");
        } else {
          alert(err?.message || "Something went wrong. Please try again.");
        }
      }
    );
  };
  return (
    <>
      <Header />
      <MobileHeader />
      <div className="contact-us-page">
        <Container>
          <div className="contact-form-wrapper">
            <div className="contact-form">
              <h1>Contact Us</h1>
              <Form onSubmit={handleContactUs}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    isInvalid={!!validationErrors.name}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.name}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    isInvalid={!!validationErrors.email}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.email}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Select
                  aria-label="Default select"
                  className="mb-3"
                  name="who_am_i"
                  value={formData.who_am_i}
                  onChange={handleChange}
                  required
                >
                  <option value="creator">I Am Creator</option>
                  <option value="brand">I Am Brand</option>
                </Form.Select>
                <Form.Control
                  as="textarea"
                  placeholder="Leave a comment here"
                  className="mb-3"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  isInvalid={!!validationErrors.message}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {validationErrors.message}
                </Form.Control.Feedback>
                <ThemeButtom
                  className="contact-btn"
                  title={isLoading ? "Sending..." : "Contact Us"}
                  disabled={isLoading}
                  type="submit"
                />
              </Form>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
